module.exports = {"540425100":"竹瓦根镇","540425101":"上察隅镇","540425102":"下察隅镇","540425200":"古玉乡","540425201":"古拉乡","540425202":"察瓦龙乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/540425.json
// module id = 2525
// module chunks = 0